<div class="text-xs font-bold">
	<ng-content select="[title]"></ng-content>
</div>

<div class="mt-0.5 text-xs whitespace-pre-line">
	<ng-content></ng-content>
</div>

<div class="flex items-center justify-start" [class.mt-1]="showGotIt || showFooter">
	<button
		class="text-xs underline"
		[style.display]="showFooter ? 'block' : 'none'"
		(mousedown)="$event.preventDefault()"
		(click)="footerClicked$.emit(); $event.stopPropagation()"
	>
		<ng-content select="[footer]"></ng-content>
	</button>

	<div class="flex-auto h-0"></div>

	@if (showGotIt) {
		<button
			uiNewButtonOutline
			variant="WHITE"
			size="SMALL"
			(mousedown)="$event.preventDefault()"
			(click)="markAsSeen(); $event.stopPropagation()"
		>
			Got It
		</button>
	}
</div>
